import {
	LOCALSTORAGE_METHODS as LocalStorageMethodEnum,
	localStorageService,
} from "src/general/utils/local-storage.service";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuth } from "src/business.InterfaceLayer/store/entities/auth.entity/redux/type";
import MAIN_PATHS from "../../../../mainPaths";
import { AUTH_FIELDS } from "../fields";
import logout from "../../../../services/utils.service/logout";

export const initialAuthState: IAuth = {
	[AUTH_FIELDS.TOKEN_ACCESS]: null,
	[AUTH_FIELDS.TOKEN_REFRESH]: null,
	[AUTH_FIELDS.IS_NEED_CHANGE]: null,
	[AUTH_FIELDS.ROLE]: null,
	[AUTH_FIELDS.USER_ID]: null,
};

export const authSlice = createSlice({
	name: `${MAIN_PATHS.AUTHORIZATION}Container`,
	initialState: initialAuthState,
	reducers: {
		login(state, action: PayloadAction<IAuth>) {
			action.payload[AUTH_FIELDS.TOKEN_ACCESS] &&
				localStorageService(LocalStorageMethodEnum.SET, {
					key: AUTH_FIELDS.TOKEN_ACCESS,
					data: action.payload[AUTH_FIELDS.TOKEN_ACCESS],
				});
			action.payload[AUTH_FIELDS.TOKEN_REFRESH] &&
				localStorageService(LocalStorageMethodEnum.SET, {
					key: AUTH_FIELDS.TOKEN_REFRESH,
					data: action.payload[AUTH_FIELDS.TOKEN_REFRESH],
				});
			localStorageService(LocalStorageMethodEnum.SET, {
				key: AUTH_FIELDS.IS_NEED_CHANGE,
				data: action.payload[AUTH_FIELDS.IS_NEED_CHANGE]
					? String(action.payload[AUTH_FIELDS.IS_NEED_CHANGE])
					: "false",
			});
			return {
				...state,
				...action.payload,
			};
		},
		logout() {
			logout();

			return initialAuthState;
		},
		setIsNeedChange(state, action: PayloadAction<"true" | "false">) {
			localStorageService(LocalStorageMethodEnum.SET, {
				key: AUTH_FIELDS.IS_NEED_CHANGE,
				data: action.payload,
			});
			return {
				...state,
				[AUTH_FIELDS.IS_NEED_CHANGE]: action.payload,
			};
		},
	},
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
